function getQueryParam(key) {
    return new URLSearchParams(window.location.search).get(key);
}
function setQueryParam(key, value) {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    window.history.replaceState(undefined, "", `${window.location.pathname}?${params.toString()}`);
}
export function getShareableSetting(key) {
    return getQueryParam(key) ?? localStorage.getItem(key);
}
export function decodeShareableSetting(key, decoder) {
    return decoder(getQueryParam(key)) ?? decoder(localStorage.getItem(key));
}
export function encodeShareableSetting(key, value, encoder) {
    const encoded = encoder(value);
    setShareableSetting(key, encoded);
}
export function setShareableSetting(key, value) {
    setQueryParam(key, value);
    localStorage.setItem(key, value);
}
//# sourceMappingURL=transforms.js.map